import React from 'react';
import { useSelector } from 'react-redux';
import { select3dRTQResult } from '../../../../../RiskTolerance/RiskToleranceSelector';
import { HiddenLeversRiskScoreEmpty } from './HiddenLeversRiskScore.empty';
import { RiskScore } from './components/RiskScore';

interface HiddenLeversRiskScoreProps {
  onRetakeAssessment: () => void;
}

export const HiddenLeversRiskScore = ({ onRetakeAssessment }: HiddenLeversRiskScoreProps) => {
  const result = useSelector(select3dRTQResult);

  const { riskScore } = result;

  if (riskScore === null) {
    return <HiddenLeversRiskScoreEmpty onRetakeAssessment={onRetakeAssessment} />;
  }

  return <RiskScore onRetakeAssessment={onRetakeAssessment} result={result} />;
};
